import { render, staticRenderFns } from "./decision_log_panel.vue?vue&type=template&id=36d6afff"
import script from "./decision_log_panel.vue?vue&type=script&lang=js"
export * from "./decision_log_panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports